(function () {
  function initVideoSlider(root) {
    if (root._vs11Init) return;
    root._vs11Init = true;

    var blockId = root.id.replace('block-', '');
    var swiperEl = root.querySelector('.vs11-swiper');
    var prevBtn = root.querySelector('.vs11-prev');
    var nextBtn = root.querySelector('.vs11-next');

    if (window.Swiper && swiperEl) {
          new window.Swiper(swiperEl, {
        slidesPerView: 'auto',
        simulateTouch: true,
        grabCursor: true,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
          disabledClass: 'vs11-arrow-disabled'
        }
      });

      root.classList.add('vs11-nav-ready');
    }

    // Hover-to-autoplay preview
    root.querySelectorAll('[data-video-slider-item]').forEach(function (item) {
      var video = item.querySelector('video');
      if (video) {
        item.addEventListener('mouseenter', function () {
          video.play().catch(function () {});
        });
        item.addEventListener('mouseleave', function () {
          video.pause();
          video.currentTime = 0;
        });
      }

      // Click -> open modal
      item.addEventListener('click', function () {
        openModal(blockId, item.dataset.videoSrc, item.dataset.videoPoster);
      });
    });
  }

  function openModal(blockId, src, poster) {
    var modalId = 'vs11-modal-' + blockId;
    var modal = document.getElementById(modalId);
    if (!modal || !src) return;

    var video = modal.querySelector('.vs11-modal-video');
    video.src = src;
    if (poster) video.poster = poster;
    video.muted = false;
    video.currentTime = 0;

    var playIcon = modal.querySelector('.vs11-icon-play');
    var pauseIcon = modal.querySelector('.vs11-icon-pause');
    var soundOnIcon = modal.querySelector('.vs11-icon-sound-on');
    var soundOffIcon = modal.querySelector('.vs11-icon-sound-off');
    var playPauseBtn = modal.querySelector('.vs11-modal-playpause');
    var muteBtn = modal.querySelector('.vs11-modal-mute');

    function syncPlayIcon() {
      playIcon.style.display = video.paused ? '' : 'none';
      pauseIcon.style.display = video.paused ? 'none' : '';
    }
    function syncMuteIcon() {
      soundOnIcon.style.display = video.muted ? 'none' : '';
      soundOffIcon.style.display = video.muted ? '' : 'none';
    }

      if (!playPauseBtn._vs11Bound) {
      playPauseBtn._vs11Bound = true;
      playPauseBtn.addEventListener('click', function () {
        if (video.paused) video.play(); else video.pause();
      });
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        syncMuteIcon();
      });
      video.addEventListener('play', syncPlayIcon);
      video.addEventListener('pause', syncPlayIcon);

      var closeBtn = modal.querySelector('.vs11-modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (window.MicroModal) window.MicroModal.close(modalId);
        });
      }
    }

    if (window.MicroModal) {
      window.MicroModal.show(modalId, {
        onShow: function () {
          document.body.classList.add('overflow-hidden');
          video.play().catch(function () {});
          syncPlayIcon();
          syncMuteIcon();
        },
        onClose: function () {
          document.body.classList.remove('overflow-hidden');
          video.pause();
          video.removeAttribute('src');
          video.load();
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.vs11-root').forEach(initVideoSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();